//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum KnowledgeBaseAccessibility {
	Public = 0,
	Private = 1,
	PublicWithAuth = 2
}
